// Set just before a theme hands off to Cashfree. Cashfree's return_url always
// points at the main /order-success page; App.js reads this key there and
// forwards the shopper back into the theme they paid from. Kept dependency-free
// so the main store bundle doesn't pull in any theme code.
export const THEME_RETURN_KEY = "theme_return";

export function markThemeReturn(base) {
  try {
    sessionStorage.setItem(THEME_RETURN_KEY, `${base}|${Date.now()}`);
  } catch {}
}

// The theme to return to after Cashfree, if the hand-off happened recently
export function takeThemeReturn() {
  try {
    const raw = sessionStorage.getItem(THEME_RETURN_KEY);
    if (!raw) return null;
    sessionStorage.removeItem(THEME_RETURN_KEY);
    const [base, ts] = raw.split("|");
    return Date.now() - Number(ts) < 60 * 60 * 1000 ? base : null;
  } catch {
    return null;
  }
}
